<template>
  <div class="newsCenter">
    <Menu></Menu>
    <div id="newsCenter" style="margin-top: 80px;">
		<div class="index-first-screen">
			<img src="../assets/img/about.jpg" alt="" class="pcStyle" />
			<img src="../assets/img/aboutMb.jpg" alt="" class="mbStyle"/>
			<div class="index-first-screen-box">
				<div class="index-first-screen-title">联系我们</div>
				<div class="index-first-screen-text">Contact us</div>
			</div>
		</div>
		<div class="contactUs">
			<div class="contactUs-box">
				<div class="contactUs-box-left">
					<div class="contactUs-box-left-box">
						<div class="contactUs-box-rong">
							<img src="../assets/img/rong1.png" alt="" />
						</div>
						<div class="contactUs-box-text">
							<div class="contactUs-box-text-a">地址</div>
							<div>哈尔滨市松北区智谷二街3043号8号楼8层</div>
						</div>
					</div>
					<div class="contactUs-box-left-box">
						<div class="contactUs-box-rong">
							<img src="../assets/img/rong1.png" alt="" />
						</div>
						<div class="contactUs-box-text">
							<div class="contactUs-box-text-a">邮编</div>
							<div>150000</div>
						</div>
					</div>
					<div class="contactUs-box-left-box">
						<div class="contactUs-box-rong">
							<img src="../assets/img/rong1.png" alt="" />
						</div>
						<div class="contactUs-box-text">
							<div class="contactUs-box-text-a">联系电话</div>
							<div>400-0451-000</div>
						</div>
					</div>
					<div class="contactUs-box-left-box">
						<div class="contactUs-box-rong">
							<img src="../assets/img/rong1.png" alt="" />
						</div>
						<div class="contactUs-box-text">
							<div class="contactUs-box-text-a">邮箱</div>
							<div>zyhbgroup@163.com</div>
						</div>
					</div>
				</div>
				<div class="contactUs-box-right">
					
				</div>
			</div>
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'newsCenter',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		
      };
    },
	mounted(){
		
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/aboutUs.scss';

</style>


// WEBPACK FOOTER //
// src/components/aboutUs.vue